'use strict';
/**
 * [init initilizes tabs]
 * @param  {[string]} scope [css selector]
 * @return {[undefined]}    [nothing returned]
 */
export function init(scope){


    alertify.pdf = function (msg) {
        alertify.set({ labels: { ok: '' } });
        alertify.alert(msg, $.noop, 'pdf-dialog');
        alertify.set({ labels: { ok: 'Luk' } });
    };

    if($('.pdf').length){
        var tpl     = $('.pdf-box');
        var regTpl  = tpl.find('.pdf-box-register');
        var confirmTpl  = tpl.find('.pdf-box-confirm');

        // Remove dupe
        regTpl.detach();

        $('.pdf').on('click', function(){

            alertify.pdf(regTpl.html());

            $('.js-reg-form').off().on('submit', function(e){
                var form = $(this);
                $.validator.unobtrusive.adapters.addBool("mandatory", "required");
                $.validator.unobtrusive.parse(".js-reg-form");

                if (form.valid()) {
                    var submitBtn = form.find('[type=submit]');

                    submitBtn.addClass('btn--disabled');

                    $.ajax({
                        type: 'POST',
                        url: form.attr('action'),
                        data: $(this).serialize(),
                        success: function(data) {
                            if (data.success) {
                                var serverErrorDiv = $('.server-error');
                                if (!serverErrorDiv.hasClass('hide')) {
                                    serverErrorDiv.addClass('hide');
                                }
                                $('.pdf-dialog').hide();
                                $('.alertify-button-ok').click();
                                alertify.pdf(confirmTpl.html());
                               
                                $('.alertify-alert').show();
                                submitBtn.removeClass('btn--disabled');
                                
                            } else {
                                var serverError = $('.server-error');
                                serverError.find('li').text(data.errorMsg);
                                if (serverError.hasClass('hide')) {
                                    serverError.removeClass('hide');
                                }
                                submitBtn.removeClass('btn--disabled');
                            }
                        }
                    });
                }
                e.preventDefault();
            });
            return false;
        });
       

        $('body').on('click touchend', '.pdf-box-confirm-inner .btn, .alertify-cover', function(ev){
            $('.alertify-button-ok').click();
            ev.preventDefault();
        });


    }


}
